import React from "react";
import ReactDOM from "react-dom";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import * as Sentry from "@sentry/react";

import App from "./App";
import translations from "./translations";

if (process.env.NODE_ENV === "production")
  Sentry.init({
    dsn:
      "https://9d3747d6a5b844439bc13b16895bf92b@o432140.ingest.sentry.io/5384374",
  });

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: translations,
    fallbackLng: "bg",
    interpolation: {
      escapeValue: false,
    },
  });

ReactDOM.render(<App />, document.getElementById("root"));
